import valueIsArray from './valueIsArray';
import { TypeAssertion } from './valueIsShapeAssertion';

const valueIsArrayOfAssertion = <T>(assertion: TypeAssertion<T>) =>
	((value: unknown): value is T[] => {
		if (!valueIsArray(value)) {
			return false;
		}

		const elementThatDontMatch = value.find((propVal) => !assertion(propVal));

		return !elementThatDontMatch;
	}) as TypeAssertion<T[]>;

export default valueIsArrayOfAssertion;
